module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjgwMCIgdmlld0JveD0iLTYwIC00MCAxMjAgODAiIHdpZHRoPSIxMjAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNlNzAwMTMiPjxwYXRoIGQ9Ik0tNjAtNDBINjB2ODBILTYweiIvPjxjaXJjbGUgZmlsbD0iI2ZmZiIgcj0iMjAiLz48cGF0aCBkPSJNMC0xNUExNSAxNSAwIDAgMC0xNSAwIDE1IDE1IDAgMCAwIDAgMTVhMTUgMTUgMCAwIDAgMTIuMTAyLTYuMTY1QTEyIDEyIDAgMCAxIDQgMTIgMTIgMTIgMCAwIDEtOCAwIDEyIDEyIDAgMCAxIDQtMTJhMTIgMTIgMCAwIDEgOC4xMDEgMy4xNjdBMTUgMTUgMCAwIDAgMC0xNXoiIHN0cm9rZS13aWR0aD0iMTAiLz48cGF0aCBkPSJNLTUgMGwxNi4yODEtNS4yOUwxLjIyIDguNTZWLTguNTZMMTEuMjggNS4yOXoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tun.svg
// module id = lA0U
// module chunks = 0